import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CaoService } from 'src/app/services/cao.service';
import { BaseService } from 'src/app/services/common/base.service';
import { TokenService } from 'src/app/services/common/token.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-tank-stage1-pfms-e-sparsh',
  templateUrl: './tank-stage1-pfms-e-sparsh.component.html',
  styleUrls: ['./tank-stage1-pfms-e-sparsh.component.scss']
})
export class TankStage1PfmsESparshComponent implements OnInit {
  @Input() lotDetails: string;
  @ViewChild('pondSubsidyPFMSReportTable', { static: true }) public pondSubsidyPFMSReportTable: any;

  @ViewChild('miSurvey', { static: false }) public miSurveyTable: any;

  selectedBankAccounts: any[];

  submitted: boolean;
  menuItems: MenuItem[];

  statuses: any[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  pondSubsidyPFMSReportModel: any[];
  addDialog: boolean;

  lotNo: number;
  public filteredData: any = [];
  selectedStatus: any;
  remarks: String;
  date: any;
  public userID: any;
  miSurveyData: any[];
  items: any[];
  appVerificationItems: MenuItem[];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  filteredDataForExport: any = [];
  ipAddress: any = '000.000.000';
  public loading: boolean = false;
  public loading1: boolean = false;
  public subscriptions: any = [];

  public subjectSub:any;
  public selectedYear:any;

  // totals for current page and grand totals
  public stage1PageTotals: any = { centerShare: 0, stateShare: 0, topUp: 0, subsidyToFarmer: 0 };
  public stage1GrandTotals: any = { centerShare: 0, stateShare: 0, topUp: 0, subsidyToFarmer: 0 };

  // new flag to ensure initial page computation runs only once per dialog open
  private miPageComputedOnce: boolean = false;
  public isDuplicateFound: boolean = false;

  constructor(
    private messageService: MessageService, 
    private caoService: CaoService, 
    private router: Router, 
    private tokenService: TokenService, 
    private cryptoJsService: CryptoJsService, 
    private deptDashBoardService: DepartmentDashboardService, 
    private ipService: IpAddressService, 
    private dashboard: DashboardService,  
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService
    ) { }

  ngOnInit() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    // this.loadData();
    this.loadDataAndApplyFilter();
    this.date = new Date();

    this.getIP();
    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.pondSubsidyPFMSReportModel, "Pond Survey Tank Stage 1 PFMS Report- DBT");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.pondSubsidyPFMSReportModel, "Pond Survey Tank Stage 1 PFMS Report");
      //   }
      // },
    ];

    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.pfmsExportExcel(this.miSurveyData, `${this.lotNo}_(${this.date})`);
        }
      },
    ];

  }
  
  
  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    if(this.lotDetails){
      this.loadData();
    }else{
      this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
        (res) => {
          this.loadData();
     
          this.selectedYear = res;
          this.pondSubsidyPFMSReportTable.filters['FinYear'] = [
            { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
        }
      );
    }
  }
  
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  onFiltering(event: any) {
    // console.log('Filtered value: ' + JSON.stringify(event.filters));
  }

  loadData() { 
    // this.loader.start();
    this.loading = true;
    let reqBody = {
      Stage: 1,
      UserType: "Farmer,7500",
      FinYear: ''
    }
    if(this.lotDetails != undefined){
      reqBody = {
        Stage: 1,
        UserType: '',
        FinYear: this.lotDetails?.['F.Y.']
      }
    }

    this.loading = true;
    let sub= this.caoService.getApplicatonsForPondSubsidyPFMSReportsByStageId(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
         // this.loader.close();
         this.loading = false;
          data = data.map(val => ({ 
            ...val,
            lotNoForSorting: parseInt(val?.Lot_No.slice(7))
          }))
          this.activityRecordService.activityRecord(this.userID, 'Tank Stage-1 PFMS Report (PDMC)', '', new Date(), 'Success');

          if (data.length > 0) {
            this.pondSubsidyPFMSReportModel = data;
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.userID, 'Tank Stage-1 PFMS Report (PDMC)', '', new Date(), err);

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error!  not loaded.' });

        }
      });
      this.subscriptions.push(sub);
  }

  hideDialog() {
    this.addDialog = false;
    this.miSurveyData = [];
    this.isDuplicateFound = false;
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Sr No": d.Srno,
          "File No": d.Lot_No,
          "Date of Export": d.dateofExport,
          "No of Record": d.No_of_AllRecords,
          "Sum of PFMS Export": d.Sum_of_PFMS_Export,
          "Sum of Center Share Amount": d.Sum_of_Centre_Share,
          "Sum of State Share Amount": d.Sum_of_State_Share,
          "Sum of TopUp Amount": d.SumOfTopUp_AllRec,
          "Sum of ABY Amount": d.SumOfABY_AllRec,
          "No of Successfull Records": d.No_of_Successfull_Records,
          "Sum of Successfull Records": d.Sum_of_Successfull_Records,
          "No of Failed Records": d.No_of_Failed_Records,
          "Sum of Failed Records": d.Sum_of_Failed_Records,
          "Sum of Bank Transfer Successfull Records": d.Sum_of_Bank_Transfer_Successfull_Records,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  refreshTable(){
    this.loadData();
  }

  pmfsExport(lotId, status) {
    this.addDialog = true;
    this.lotNo = lotId;
    let tankStage = 1;
    this.loading1 = true;
    this.miSurveyData = [];
    this.miPageComputedOnce = false;
    this.stage1PageTotals = { centerShare: 0, stateShare: 0, topUp: 0, subsidyToFarmer: 0 };
    this.stage1GrandTotals = { centerShare: 0, stateShare: 0, topUp: 0, subsidyToFarmer: 0 };

    // this.loader.start();
    this.caoService.getApplicationsForPondFarmerShareToVendorPFMSExportByLotId(lotId, tankStage, status, 'farmer,7500' )
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading1 = false;
          if (data?.length > 0) {
            this.miSurveyData = data;
            const flag = this.hasDuplicate(data);
            if(flag['duplicate'] == true) {
              this.isDuplicateFound = true;
              this.messageService.add({ 
                severity: 'warn', 
                summary: 'Warn Message', 
                detail: `Duplicate values found in the data. Please contact to technical team. Duplicate ${flag['type']} : ${flag['value']}`,
                sticky: true,
                closable: true
              });
            } else {
              this.isDuplicateFound = false;
            }

            this.miSurveyData = this.miSurveyData.map(row => ({
              ...row,
              AppId_ProgID: row.Scheme_Specific_Id.concat("_", row.ProgramID),
              totalAmountSum: row?.Center_Share_Payment_Amount + row?.State_Share_Payment_Amount,
            }))

            setTimeout(() => {
              this.computeTotals();
              // if (!this.miPageComputedOnce) {
              //   this.computeTotals();
              //   this.miPageComputedOnce = true;
              // }
            }, 0);
          }
          else{
            this.isDuplicateFound = false;
            this.miSurveyData = [];
            setTimeout(() => {
              this.computeTotals();
              this.miPageComputedOnce = true;
            }, 0);
            
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
          this.activityRecordService.activityRecord(this.userID, 'Tank Stage-1 PFMS Export (DBT)', lotId, new Date(), 'Success');
        },
        error: (err) => {
          this.isDuplicateFound = false;
          this.loading1 = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
          this.activityRecordService.activityRecord(this.userID, 'Tank Stage-1 PFMS Export (DBT)', lotId, new Date(), err);
        }
      });
  }

  hasDuplicate(records) {
    const appIds = new Set();
    const aadhars = new Set();

    for (const item of records) {
      if (appIds.has(item.Scheme_Specific_Id)) {
        return { duplicate: true, type: "AppId", value: item.Scheme_Specific_Id };
      }
      if (aadhars.has(item.Aadhar_Number)) {
        return { duplicate: true, type: "Aadhar", value: item.Aadhar_Number };
      }

      appIds.add(item.AppId);
      aadhars.add(item.Aadhar_Number);
    }

    return { duplicate: false };
  }

  // compute both grand totals and page totals (current visible page)
  computeTotals() {
    const all = Array.isArray(this.miSurveyData) ? this.miSurveyData : [];

    // grand totals (all rows)
    const grand = all.reduce((acc, row) => {
      acc.centerShare += Number(row?.Center_Share_Payment_Amount) || 0;
      acc.stateShare += Number(row?.State_Share_Payment_Amount) || 0;
      acc.topUp += Number(row?.TopUp) || 0;
      acc.subsidyToFarmer += Number(row?.totalAmountSum) || 0;
      return acc;
    }, { centerShare: 0, stateShare: 0, topUp: 0, subsidyToFarmer: 0 });

    this.stage1GrandTotals = grand;

    // page totals (use table.first and table.rows if available)
    let pageRows = all;
    if (this.miSurveyTable && Array.isArray(this.miSurveyTable.value)) {
      const first = Number(this.miSurveyTable.first) || 0;
      const rows = Number(this.miSurveyTable.rows) || this.miSurveyTable.value.length;
      pageRows = this.miSurveyTable.value.slice(first, first + rows);
    }

    const page = (Array.isArray(pageRows) ? pageRows : []).reduce((acc, row) => {
      acc.centerShare += Number(row?.Center_Share_Payment_Amount) || 0;
      acc.stateShare += Number(row?.State_Share_Payment_Amount) || 0;
      acc.topUp += Number(row?.TopUp) || 0;
      acc.subsidyToFarmer += Number(row?.totalAmountSum) || 0;
      return acc;
    }, { centerShare: 0, stateShare: 0, topUp: 0, subsidyToFarmer: 0 });

    this.stage1PageTotals = page;
  }

  // handler when table filters change
  onMiSurveyFilter(event: any) {
    // recompute totals - filtered view affects table.value/filteredValue depending on PrimeNG version
    // delay slightly to let table update filteredValue
    setTimeout(() => this.computeTotals(), 0);
  }

  // handler when paging
  onMiSurveyPage(event: any) {
    // event contains first and rows; compute using table slice
    setTimeout(() => this.computeTotals(), 0);
  }

  pfmsExportExcel(modelData, filename) {
    this.countNoOfTimesExported();
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      // build rows for sheet
      let dataToSave = modelData.map((d: any) => {
        return {
          'Farmer Name': d.Farmer_Name_In_English,
          'Aadhaar Number': d.Aadhar_Number ? d.Aadhar_Number.toString() : '',
          'Scheme Specific ID': d.Scheme_Specific_Id,
          'Center Share Payment Amount': Number(d.Center_Share_Payment_Amount) || 0,
          'State Share Payment Amount': Number(d.State_Share_Payment_Amount) || 0,
          'Amount': Number(d?.totalAmountSum) || 0,
          'Top Up': Number(d.TopUp) || 0,
          'Applicant Type': d?.Applicant_Type || '',
        }
      });

      // compute grand totals and append as final row (with one blank row before totals)
      const grand = (modelData || []).reduce((acc: any, row: any) => {
        acc.centerShare += Number(row?.Center_Share_Payment_Amount) || 0;
        acc.stateShare += Number(row?.State_Share_Payment_Amount) || 0;
        acc.topUp += Number(row?.TopUp) || 0;
        acc.subsidyToFarmer += Number(row?.totalAmountSum) || 0;
        return acc;
      }, { centerShare: 0, stateShare: 0, topUp: 0, subsidyToFarmer: 0 });

      // push an empty row then the grand total row
      dataToSave.push({
        // empty row - keep keys so columns align
        'Farmer Name': '',
        'Aadhaar Number': '',
        'Scheme Specific ID': '',
        'Center Share Payment Amount': '',
        'State Share Payment Amount': '',
        'Amount': '',
        'Top Up': '',
      });
      dataToSave.push({
        'Farmer Name': 'Grand Total',
        'Aadhaar Number': '',
        'Scheme Specific ID': '',
        'Center Share Payment Amount': grand.centerShare,
        'State Share Payment Amount': grand.stateShare,
        'Amount': grand.subsidyToFarmer,
        'Top Up': grand.topUp,
      });

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  countNoOfTimesExported(){
    let reqBody = {
      lotType: 'STF',
      subLotType: 'PDMC',
      lotNo: this.lotNo,
      userId: this.userID,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress 
    }

    this.postCountExportDataFrequency(reqBody);
  }


  selectFarmerApplication(application) {
    if(application.Scheme_Specific_Id){
      this.loader.start();
      this.dashboard
      .getMIDetailByAppID(application.Scheme_Specific_Id)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          const link = this.router.serializeUrl(
            this.router.createUrlTree([
              this.router.url.split('/')[1],
              'print',
            ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.Scheme_Specific_Id.toString()) } }));
          // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.Scheme_Specific_Id), ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
          window.open(link, '_blank');
        },
        error: (err) => {
          this.loader.close();
          // console.log("error", err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  postCountExportDataFrequency(reqBody) {
    this.loader.start();
    this.deptDashBoardService
      .postCountExportDataFrequency(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if(data.Result == 'Success'){
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: data.Result,
            });
          }else {
            this.messageService.add({
              severity: 'info',
              summary: 'Status',
              detail: data.Result,
            });
          }
          this.loadData();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  rowBackgroundColor(row) {
    if (row.PendingCompletedDays <= -2) {
      //red
      return '#ff8080';
    }else if (row.PendingCompletedDays == -1) {
      //orange
      return '#ffc966';
    }else if (row.PendingCompletedDays == 0) {
      //light green
      return '#99e699'
    }else return '#ffffff'; 
  }
}

